module.exports = __webpack_public_path__ + "media/images/badges/clubpilates/milestone-3-Inactive-ClubPilates-0f9a2fe5064264d219e3cf9006db6200.png";